import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import TermsModal from '../components/TermsModal';

function Register({ onLogin }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [department, setDepartment] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/register`, {
        name,
        email,
        password,
        department,
      });

      // Login directly after registration
      onLogin(response.data.user, response.data.access_token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="register-page">
      <div className="auth-box">
        <div className="auth-logo">
          <img 
            src="/stewie_front.png"
            alt="Stewie Logo"
            className="auth-logo-image"
          />
          Ask Stewie
        </div>
        <p className="auth-subtitle">Join the union resource platform</p>

        {error && <div className="error-message" data-testid="register-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Full Name</label>
            <input
              type="text"
              className="form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              data-testid="register-name-input"
              placeholder="John Doe"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="register-email-input"
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Department</label>
            <input
              type="text"
              className="form-input"
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              required
              data-testid="register-department-input"
              placeholder="e.g., Electrical, Maintenance, Installation"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="6"
              data-testid="register-password-input"
              placeholder="Minimum 6 characters"
            />
          </div>

          <div className="form-group terms-checkbox-group">
            <label className="terms-checkbox-label">
              <input
                type="checkbox"
                checked={agreedToTerms}
                onChange={(e) => setAgreedToTerms(e.target.checked)}
                required
                data-testid="terms-checkbox"
                className="terms-checkbox-input"
              />
              <span className="terms-text">
                I agree to the{' '}
                <button
                  type="button"
                  className="terms-link"
                  onClick={() => setShowTermsModal(true)}
                  data-testid="view-terms-button"
                >
                  Terms of Use and Privacy Policy
                </button>
              </span>
            </label>
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading || !agreedToTerms}
            data-testid="register-submit-button"
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} />

        <div className="auth-link">
          Already have an account? <Link to="/login" data-testid="login-link">Sign in here</Link>
        </div>

        <div className="qr-code-section">
          <p className="qr-label">Share this app</p>
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin)}`}
            alt="QR Code to access Ask Stewie"
            className="qr-code-image"
            data-testid="qr-code"
          />
          <p className="qr-hint">Scan to access on mobile</p>
        </div>
      </div>
    </div>
  );
}

export default Register;
